<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { copyTextToClipboard } from 'shared/helpers/clipboard';

const props = defineProps({
  details: { type: Object, required: true },
});
const { t } = useI18n();
const copyStatus = ref('');
const pix = computed(() => {
  const settings =
    props.details.payment_settings || props.details.paymentSettings || [];
  const setting = settings.find(item => item.type === 'pix_dynamic_code');
  return setting?.pix_dynamic_code || setting?.pixDynamicCode;
});
const amount = computed(() => {
  const total = props.details.total_amount || props.details.totalAmount;
  if (!total || total.offset !== 100 || !Number.isInteger(total.value))
    return '';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(total.value / 100);
});
const merchant = computed(
  () => pix.value?.merchant_name || pix.value?.merchantName
);
const copy = async () => {
  try {
    await copyTextToClipboard(pix.value.code);
    copyStatus.value = t('CONVERSATION.INTERACTIVE.PIX.COPIED');
  } catch {
    copyStatus.value = t('CONVERSATION.INTERACTIVE.PIX.COPY_ERROR');
  }
};
</script>

<template>
  <div
    v-if="pix?.code"
    class="grid gap-2 rounded-xl border border-n-weak bg-n-alpha-1 p-3"
  >
    <span class="text-xs font-medium">{{
      t('CONVERSATION.INTERACTIVE.PIX.TITLE')
    }}</span>
    <span class="text-xl font-semibold tabular-nums">{{ amount }}</span>
    <span class="text-sm">{{ merchant }}</span>
    <button
      type="button"
      class="skip-context-menu flex items-center justify-center gap-2 rounded-lg bg-n-solid-2 px-3 py-2 text-sm font-medium text-n-slate-12 hover:bg-n-alpha-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
      @click.stop="copy"
    >
      <span class="i-hugeicons-copy-01 size-4" aria-hidden="true" />
      {{ t('CONVERSATION.INTERACTIVE.PIX.COPY') }}
    </button>
    <span v-if="copyStatus" class="text-xs" role="status">{{
      copyStatus
    }}</span>
  </div>
  <span v-else class="hidden" />
</template>
